import { render, staticRenderFns } from "./index.vue?vue&type=template&id=aa55f08a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa55f08a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\crmeb\\gitcode\\mer_plat_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aa55f08a')) {
      api.createRecord('aa55f08a', component.options)
    } else {
      api.reload('aa55f08a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=aa55f08a&scoped=true", function () {
      api.rerender('aa55f08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/category/index.vue"
export default component.exports